import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Modal } from 'react-bootstrap';

import Button from '../../components/Button/Button'
import { formatNumber, shortenPriceObj } from '../../utils/Utils';

const SHORTEN_VALUE = 999999;
const DAILY_AUCTION_POOL = '139.51M';
const FIRST_DAY_AUCTION_POOL = '419M';

const AuctionTableMobile = (props) => {
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [showExitAuctionModal, setShowExitAuctionModal] = useState({ show: false, day: 0 });

    useEffect(() => {
        setData(props.data);
    }, [props.data]);

    const formatValue = (val) => {
        let shortenPrice = shortenPriceObj(val);
        if (val > SHORTEN_VALUE) {
            let value = shortenPrice.price.toFixed(2);
            let suffix = shortenPrice.suffix;
            return `${value}${suffix}`;
        } else {
            return formatNumber(val.toFixed(4));
        }
    }

    const ExitAuctionModal = () => {
        return (
            <Modal
                id="tron-listener-modal"
                show={showExitAuctionModal.show}
                onHide={_ => setShowExitAuctionModal({ show: false })}
                centered>
                <Modal.Header>
                    <Modal.Title>{t('Attention')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>Exit all bid for day {showExitAuctionModal.day + 1}</div>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        title={'Cancel'}
                        containerStyle={{ padding: '6px 20px', margin: '10px', backgroundColor: '#898989' }}
                        titleStyle={{ fontSize: '18px' }}
                        onClick={() => {
                            setShowExitAuctionModal({ show: false });
                        }}
                    />
                    <Button
                        title={'Exit Bid'}
                        containerStyle={{ padding: '6px 20px', margin: '10px' }}
                        titleStyle={{ fontSize: '18px' }}
                        onClick={() => {
                            setShowExitAuctionModal({ show: false });
                            props.onExitBidPress(showExitAuctionModal.day);
                        }}
                    />
                </Modal.Footer>

            </Modal>
        )
    }

    return (
        <div className="outer-content-wrapper auction-bottom-container">
            <ExitAuctionModal />
            <div className="content-wrapper ">
                <div style={{ padding: "12px 0px" }}>
                    <div><span className="font-sf-pro auction-table-title">Day</span></div>
                    {data && data.map((dayRecord) => {
                        let status = "";
                        let auctionRate = 0;
                        let dailyAuctionPool = DAILY_AUCTION_POOL;
                        if ((dayRecord.day + 1) === 1) dailyAuctionPool = FIRST_DAY_AUCTION_POOL;

                        if (dayRecord.day === props.currentDay.current) {
                            auctionRate = 'N/A';
                        } else if (dayRecord.usdtBid !== 0) {
                            auctionRate = formatValue(dayRecord.mosPool / dayRecord.usdtBid);
                        }

                        if (dayRecord.day !== props.currentDay.current) {
                            status = "Closed";
                        } else {
                            {/* let now = moment();
                            let midnight = moment({ hour: 23, minute: 59, seconds: 59 });
                            let hoursLeft = midnight.diff(now, 'hours') + 1; */}

                            status = `Open`;
                        }

                        return (
                            <div key={`${dayRecord.day}`}>
                                <div className="auction-table-mobile font-sf-pro">
                                    <div style={{ gridArea: '1 / 1 / 5 / 2' }} className="auction-table-cells-1"><span>{dayRecord.day + 1}</span></div>
                                    <div style={{ gridArea: '1 / 2 / 3 / 3' }} className="auction-table-mobile-cells-upper-row">
                                        <span>{t('daily auction pool')}</span>
                                        <span className="auction-table-mobile-value">{dailyAuctionPool}</span>
                                    </div>
                                    <div style={{ gridArea: '1 / 3 / 3 / 4' }} className="auction-table-mobile-cells-upper-row">
                                        <span>{t('total usdt bid')}</span>
                                        <span className="auction-table-mobile-value">{formatValue(dayRecord.usdtBid)}</span>
                                    </div>
                                    <div style={{ gridArea: '1 / 4 / 3 / 5' }} className="auction-table-mobile-cells-upper-row">
                                        <span>MOS / USDT</span>
                                        <span className="auction-table-mobile-value">{auctionRate}</span>
                                    </div>
                                    <div style={{ gridArea: '3 / 2 / 5 / 3' }} className="auction-table-mobile-cells-lower-row">
                                        <span>{t('status')}</span>
                                        <span className="auction-table-mobile-value">{status}</span>
                                    </div>
                                    <div style={{ gridArea: '3 / 3 / 5 / 4' }} className="auction-table-mobile-cells-lower-row">
                                        <span>{t('your mos')}</span>
                                        <span className="auction-table-mobile-value">
                                            {dayRecord.userInfo.claimedMos === 0 ? formatValue(dayRecord.userInfo.unclaimedMos) : formatValue(dayRecord.userInfo.claimedMos)}
                                        </span>
                                    </div>
                                    <div style={{ gridArea: '3 / 4 / 5 / 5' }} className="auction-table-mobile-cells-lower-row">
                                        <span>{t('your usdt bid')}</span>
                                        <span className="auction-table-mobile-value">{formatValue(dayRecord.userInfo.bidAmount)}</span>
                                    </div>
                                </div>
                                {status === "Closed" && dayRecord.userInfo.bidAmount > 0 && dayRecord.userInfo.unclaimedMos > 0 &&
                                    <div className="content-wrapper auction-table-mobile-exit-btn" onClick={() => { setShowExitAuctionModal({ show: true, day: dayRecord.day }) }}>Exit</div>
                                    //<div className="content-wrapper auction-table-mobile-exit-btn" onClick={() => { props.onExitBidPress(dayRecord.day) }}>Exit</div>
                                }
                            </div>
                        )
                    })}

                    {data.length === 0 &&
                        <div className="font-sf-pro" style={{ color: 'grey', textAlign: 'center' }} >None</div>
                    }
                </div>
            </div>
        </div >
    )
}

export default AuctionTableMobile;